import React, { Component } from 'react';
import { saveAs } from 'file-saver';
import { Row, Column } from 'simple-flexbox';
import Datetime from 'react-datetime';
import DatePicker from 'react-datepicker';
import { Panel, Button, Table } from "react-bootstrap";
import Pagination from '@mui/material/Pagination';
import TextareaAutosize from 'react-textarea-autosize';

import Alert from "@modules/Alert";
import ComponentHeader from "@components/componentHeader";
import Dropdowns from '@modules/apiData/dropdowns';
import Form from "@sm/core/Form";
import Modal from '@modules/Modal';
import Multiselect from "@modules/generateReport/customMultiselect";
import Select from "@modules/Select";
import Spinner from '@components/Spinner';

import "react-datepicker/dist/react-datepicker.css";
import "@assets/css/pacificCapital/generateReports.scss";
import '@assets/css/pacificCapital/apiData.scss';
import "@assets/css/t365/generateReports.scss";
import '@assets/css/t365/apiData.scss';
import "@assets/css/trustbucks/generateReports.scss";
import '@assets/css/trustbucks/apiData.scss';
import "@assets/css/generateReports.css";
import '@assets/css/apiData.css';

import Calendar from '@assets/images/calendar.png';
import ReportIcon from '@assets/images/report.png';
import ReportIconTrustbucks from '@assets/images/trustbucks/report.png';
import ReportIconT365 from '@assets/images/t365/report.png';
import ReportIconPacificCapital from '@assets/images/pacificCapital/report.png';

import { whiteLabel } from '@sm/config';
import { crudActions } from "@sm/services/crudActions";
import { getColor, getFormattedDate, convertUTCToLocalDate, convertLocalToUTCDate } from "@sm/utils/utils";
import { FETCH_PERMISSIONS } from '@sm/actions/types';
const store =  require('@sm/reducers/index');

const INTEGER_MAX = 2147483647;

const REPORT_TYPES = {
  CLOSING_BALANCE: "CLOSING_BALANCE",   // Closing Balance
  DEPOSITS_PAYOUTS: "DEPOSITS_PAYOUTS", // Transactions
  GROSS_PROFIT: "GROSS_PROFIT",         // Gross Profit
  OTC_SETTLEMENTS: "OTC_SETTLEMENTS",   // OTC Settlements
  OTC_BALANCES: "OTC_BALANCES",         // OTC Balances
  OTC_WITHDRAW: "OTC_WITHDRAW",         // OTC Withdraw
  PAYOUT: "PAYOUT",                     // Payout Report
  PERFORMANCE: "PERFORMANCE",           // Performance Report
  RUNNING_BALANCE: "RUNNING_BALANCE",   // Running Balance
  SERVER_LOGS: "SERVER_LOGS",           // Server Logs
  SETTLEMENTS: "SETTLEMENTS",           // Settlements
  TRANSACTIONS: "TRANSACTIONS",         // Deposits
};
class GenerateReport extends Component {
  state = {
    controls: {
      timePeriod: {
        id: 0,
        value:'thisMonth'
      },
      from: this.getPeriod(1).from,
      to: this.getPeriod(1).to
    },
    dateFieldDisabled: false,
    dropdowns: {
      periods: Dropdowns.periods
    },
    timeStamp: {
      fromDateTimeStamp: this.getPeriod(2).from,
      toDateTimeStamp: this.getPeriod(2).to
    },
    lastUpdate: Datetime.moment().format('HH:mm - DD. MMM YYYY'),

    depositMethod: [],
    depositStatus: [],
    depositPayoutStatus: [],
    sortBy: [],
    sortByDate: [],
    reportType: [],
    currency: [],
    baseCurrencies: [],
    displayMode: [],
    payoutMethod: [],
    payoutCountry: [],
    payoutStatus: [],
    settlementStatuses: [],
    countries: [],
    properties: [],
    transactionId: "",
    clientName: "",
    companiesClients: {},
    clientMids: [],
    clientPayoutMids: [],
    defaultTimezone: "",
    timeZoneType: "",
    timeStampList:[],
    timeZones:[],
    updateStatuses: [],

    trafficTypes: [{
      value: "FTD",
      label: "FTD"
    }, {
      value: "MIXED",
      label: "Mixed"
    }, {
      value: "TRUSTED",
      label: "Trusted"
    }],

    reportFormData: {
      clientIds: [],
      depositMethod: [],
      depositStatus: [],
      currency: [],
      sortBy: "",
      reportType: "",
      displayMode: "",
      transactionId: "",
      sortByDate: "DAY",
      companyId: "",
      midIds: [],
      timeStampList: null,
      timeZone: ""
    },

    reportFormRules: [{
      name: "clientIds",
      type: "isArray",
      rules: {
        required: true
      }
    }, {
      name: "companyId",
      type: "isNumber",
      rules: {
        required: true
      }
    }, {
      name: "sortBy",
      type: "isString",
      rules: {
        required: true
      }
    }, {
      name: "reportType",
      type: "isString",
      rules: {
        required: true
      }
    }, {
      name: "timeStampList",
      type: "isString",
      rules: {
        required: true
      }
    }, {
      name: "timeZone",
      type: "isString",
      rules: {
        required: true
      }
    }, {
      name: "displayMode",
      type: "isString",
      rules: {
        required: true
      }
    }, {
      name: "sortByDate",
      type: "isString",
      rules: {
        required: false
      }
    }, {
      name: "currency",
      type: "isArray",
      rules: {
        min: 1,
        required: true
      }
    }, {
      name: "depositMethod",
      type: "isArray",
      rules: {
        min: 1,
        required: true
      }
    }, {
      name: "depositStatus",
      type: "isArray",
      rules: {
        min: 1,
        required: true
      }
    }, {
      name: "midIds",
      type: "isArray",
      rules: {
        min: 1,
        required: true
      }
    }, {
      name: "transactionId",
      type: "isPattern",
      value:"",
      rules: {
        trim: true,
        required: false,
        pattern: "^([0-9a-zA-z#?!@$%^&*-]+)((, +| +, +| + ,|, |,| ,| , )([0-9a-zA-z#?!@$%^&*-]+))*$"
      }
    }],

    reportForm: {},

    endpointGenerateMap: {
      [REPORT_TYPES.CLOSING_BALANCE]: {
        LIST: "v1/reports/closing-balance"
      },
      [REPORT_TYPES.DEPOSITS_PAYOUTS]: {
        LIST: "v1/reports/clients/deposits_payouts"
      },
      [REPORT_TYPES.GROSS_PROFIT]: {
        LIST: "v1/reports/grossprofit/list",
        LIST_DETAILED: "v1/reports/grossprofit/list/detailed"
      },
      [REPORT_TYPES.OTC_BALANCES]: {
        LIST: "v1/reports/otc-balances/list"
      },
      [REPORT_TYPES.OTC_WITHDRAW]: {
        LIST: "v1/reports/otc-withdraw/list"
      },
      [REPORT_TYPES.OTC_SETTLEMENTS]: {
        LIST: "v1/reports/otc-settlements/list"
      },
      [REPORT_TYPES.PAYOUT]: {
        LIST: "v1/reports/payout"
      },
      [REPORT_TYPES.PERFORMANCE]: {
        LIST: "v1/reports/performance"
      },
      [REPORT_TYPES.RUNNING_BALANCE]: {
        LIST: "v1/reports/runningbalance/list"
      },
      [REPORT_TYPES.SERVER_LOGS]: {
        LIST: "v1/reports/transactions"
      },
      [REPORT_TYPES.SETTLEMENTS]: {
        LIST: "v1/reports/settlements/list"
      },
      [REPORT_TYPES.TRANSACTIONS]: {
        LIST: "v1/reports/clients/list"
      }
    },

    endpointXlsxMap: {
      [REPORT_TYPES.CLOSING_BALANCE]: {
        LIST: "v1/reports/closing-balance/xlsx"
      },
      [REPORT_TYPES.DEPOSITS_PAYOUTS]: {
        LIST: "v1/reports/clients/deposits_payouts/xlsx"
      },
      [REPORT_TYPES.GROSS_PROFIT]: {
        LIST: "v1/reports/grossprofit/list/xlsx",
        LIST_DETAILED: "v1/reports/grossprofit/list/detailed/xlsx"
      },
      [REPORT_TYPES.OTC_BALANCES]: {
        LIST: "v1/reports/otc-balances/list/xlsx"
      },
      [REPORT_TYPES.OTC_WITHDRAW]: {
        LIST: "v1/reports/otc-withdraw/list/xlsx"
      },
      [REPORT_TYPES.SETTLEMENTS]: {
        LIST: "v1/reports/otc-settlements/list/xlsx"
      },
      [REPORT_TYPES.PAYOUT]: {
        LIST: "v1/reports/payout/xlsx"
      },
      [REPORT_TYPES.PERFORMANCE]: {
        LIST: "v1/reports/performance/xlsx"
      },
      [REPORT_TYPES.RUNNING_BALANCE]: {
        LIST: "v1/reports/runningbalance/list/xlsx"
      },
      [REPORT_TYPES.SERVER_LOGS]: {
        LIST: "v1/reports/transactions/xlsx"
      },
      [REPORT_TYPES.SETTLEMENTS]: {
        LIST: "v1/reports/settlements/list/xlsx"
      },
      [REPORT_TYPES.TRANSACTIONS]: {
        LIST: "v1/reports/clients/xlsx"
      }
    },

    defaultTimePeriods: {
      [REPORT_TYPES.CLOSING_BALANCE]: {
        id: 3,
        value: 'lastMonth',
        label: 'Last Month'
      },
      [REPORT_TYPES.DEPOSITS_PAYOUTS]: {
        id: 0,
        value: 'today',
        label: 'Today'
      },
      [REPORT_TYPES.GROSS_PROFIT]: {
        id: 2,
        value: 'thisMonth',
        label: 'This Month'
      },
      [REPORT_TYPES.OTC_BALANCES]: {
        id: 0,
        value: 'today',
        label: 'Today'
      },
      [REPORT_TYPES.OTC_SETTLEMENTS]: {
        id: 2,
        value: 'thisMonth',
        label: 'This Month'
      },
      [REPORT_TYPES.OTC_WITHDRAW]: {
        id: 0,
        value: 'today',
        label: 'Today'
      },
      [REPORT_TYPES.PAYOUT]: {
        id: 0,
        value: 'today',
        label: 'Today'
      },
      [REPORT_TYPES.PERFORMANCE]: {
        id: 2,
        value: 'thisMonth',
        label: 'This Month'
      },
      [REPORT_TYPES.RUNNING_BALANCE]: {
        id: 2,
        value: 'thisMonth',
        label: 'This Month'
      },
      [REPORT_TYPES.SERVER_LOGS]: {
        id: 0,
        value: 'today',
        label: 'Today'
      },
      [REPORT_TYPES.SETTLEMENTS]: {
        id: 2,
        value: 'thisMonth',
        label: 'This Month'
      },
      [REPORT_TYPES.TRANSACTIONS]: {
        id: 0,
        value: 'today',
        label: 'Today'
      }
    },

    reportsGenerated: {},
    savedGeneratedReport: {},
    savedSelectedCompany: "",
    generatedReportType: "",
    
    modalData: "{}",
    modalType: "json",

    access: [],

    loadingRBReportId: "",
    rbIntervalID: null,
    isLoading: false,
    isLoadingLookups: true,
    showAlert: false,
    alertType: "success",
    alertMessage: "",
    successMessage: "",
    enableButton: false,

    isSortSettingsOpen: false,
    isExportSettingsOpen: false,
    isReportErrorFields: false,
    showModal: false,
    isModalLoading: false,
    currentPage: 1,
    rowsAmount: 100,
    clickButton:false,
    cnt: 0,
    periodId: 0 // today
  };

  sortNode = null;
  exportNode = null;

  // eslint-disable-next-line react/no-deprecated
  componentWillMount() {
    document.addEventListener("mousedown", this.handleClickOutside, false);
  };

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside, false);
    clearInterval(this.state.rbIntervalID);
  };

  handleClickOutside = (event) => {
    if (this.sortNode && this.sortNode.contains(event.target)) {
      this.setState({
        isExportSettingsOpen: false
      });

      return;
    }

    if (this.exportNode && this.exportNode.contains(event.target)) {
      this.setState({
        isSortSettingsOpen: false
      });

      return;
    }

    this.setState({
      isExportSettingsOpen: false,
      isSortSettingsOpen: false,
      showAlert: false,
      alertType: "success",
      alertMessage: ""
    });
  };

  thisMonth = true;

  componentDidMount() {
    const { reportFormRules, reportFormData } = this.state;
    this.setState({
      reportForm: new Form(reportFormData, reportFormRules)
    }, this.loadLookupsData);

    const storeState = store.default.getState().authReducer;
    if (storeState.access) {
      this.setState({
        access: storeState.access
      });
    }

    this.subscribeFunction = store.default.subscribe(() => {
      const state = store.default.getState().authReducer;

      if (state.userUpdate === FETCH_PERMISSIONS) {
        this.setState({
          access: state.access
        });
      }
    });
  };

  loadLookupsData() {
    const { reportForm } = this.state;

    crudActions.get(`v1/clients/current`).then(
      data => {
        if (data) {
          const currentCompanyId = data.companyId;
          this.setState({
            reportForm: Object.assign(reportForm, {
              clientIds: [data.id],
              companyId: currentCompanyId,
              midIds: data.mids || []
            }),
            clientName: data.name,
            companiesClients: {
              [currentCompanyId]: {
                value: data.id,
                label: data.name
              }
            },
            clientMids: data.mids || [],
            clientPayoutMids: data.payoutMids || [],
            defaultTimezone: data.defaultTimezone || "",
            timeZoneType: data.timeZoneType
          });
          
          Promise.all([
            crudActions.get(`v1/reports/company/${currentCompanyId}/lookups`)
          ]).then(
            (companyData) => {
              const lookups = companyData[0];
              if (lookups) {
                const filtered = Object.assign(lookups, {
                  reportType: lookups.reportType.filter(type => type.value !== REPORT_TYPES.SERVER_LOGS && type.value !== REPORT_TYPES.PAYOUT_TOP_UP_REQUEST),
                  displayMode: lookups.displayMode.filter(mode => mode.value === "LIST"),
                  sortBy: Object.assign(lookups.sortBy, {
                    [REPORT_TYPES.PERFORMANCE]: [{
                      value: "EMAIL",
                      label: "Email"
                    }, {
                      value: "IP",
                      label: "IP Address"
                    }],
                    [REPORT_TYPES.RUNNING_BALANCE]: [{
                      value: "DATE",
                      label: "Date"
                    },{
                      value: "METHOD_TYPE",
                      label: "Method"
                    }],
                    [REPORT_TYPES.CLOSING_BALANCE]: [{
                      value: "DATE",
                      label: "Date"
                    }],
                    [REPORT_TYPES.OTC_SETTLEMENTS]: [{
                      value: "DATE",
                      label: "Date"
                    }],
                    [REPORT_TYPES.OTC_BALANCES]: [{
                      value: "CURRENCY",
                      label: "Currency"
                    }],
                    [REPORT_TYPES.OTC_WITHDRAW]: [{
                      value: "DATE",
                      label: "Date"
                    }],
                  }),
                  timeZones: lookups.timeZones || [],
                  updateStatuses: lookups?.updateStatuses || [],
                  depositPayoutStatus: this.unionBy([lookups.depositStatus, lookups.payoutStatus], "value")
                });
                const reportType = lookups.reportType.find(report => report.value === REPORT_TYPES.TRANSACTIONS) || lookups.reportType[0];
                this.setState({
                  ...filtered,
                  isLoadingLookups: false
                }, () => {
                  this.onValueChange(reportType, "reportType");
                });
              }
            }
          );
        }
      }
    );
  };

  checkAccess = (permissionName) => {
    const { access } = this.state;
    const foundPermission = access.find(elem => elem.permission === permissionName);
    if (!foundPermission) {
      return false;
    }
    return foundPermission.state;
  };

  unionBy = (arrays, iteratee) => {
    const map = {};

    arrays.forEach((array) => {
      array.forEach((object) => {
        map[object[iteratee]] = object;
      });
    });

    return Object.values(map);
  };

  preselectReportFields = (reportType) => {
    const { sortBy, currency, depositMethod, depositStatus, depositPayoutStatus, properties,
      settlementStatuses, defaultTimePeriods, baseCurrencies, payoutStatus, timeStampList,
      displayMode, trafficTypes, timeZones, defaultTimezone, timeZoneType,
      updateStatuses } = this.state;

    const firstSortBy = sortBy[reportType] && sortBy[reportType][0];

    const validReportTypesForDepositMethod = [
      REPORT_TYPES.DEPOSITS_PAYOUTS,
      REPORT_TYPES.PERFORMANCE,
      REPORT_TYPES.SERVER_LOGS,
      REPORT_TYPES.TRANSACTIONS
    ];
    if (validReportTypesForDepositMethod.includes(reportType)) {
      this.onValueChange(depositMethod, "depositMethod");
    }

    if (validReportTypesForDepositMethod.filter(type => type !== REPORT_TYPES.DEPOSITS_PAYOUTS).includes(reportType)) {
      this.onValueChange(depositStatus, "depositStatus");
    }

    const validReportTypesForDeposits = [
      REPORT_TYPES.DEPOSITS_PAYOUTS,
      REPORT_TYPES.TRANSACTIONS
    ];
    if (validReportTypesForDeposits.includes(reportType)) {
      this.onValueChange(trafficTypes, "trafficTypes");
    }

    if (reportType === REPORT_TYPES.DEPOSITS_PAYOUTS) {
      this.onValueChange(depositPayoutStatus, "depositStatus");
    }

    const validReportTypesForUpdateStatus = [
      REPORT_TYPES.DEPOSITS_PAYOUTS,
      REPORT_TYPES.PAYOUT,
      REPORT_TYPES.TRANSACTIONS
    ];

    if (validReportTypesForUpdateStatus.includes(reportType)) {
      this.onValueChange(updateStatuses, "updateStatus");
    }

    const validReportTypesForTimezone = [
      REPORT_TYPES.DEPOSITS_PAYOUTS,
      REPORT_TYPES.PAYOUT,
      REPORT_TYPES.PERFORMANCE,
      REPORT_TYPES.TRANSACTIONS
    ];
    if(validReportTypesForTimezone.includes(reportType)) {
      if (defaultTimezone && timeZoneType !== "TZ_V2") {
        this.onValueChange(timeZones.find(t => t.value === defaultTimezone), "timeZone");
      } else {
        this.onValueChange(timeZones[0], "timeZone");
      }
      this.onValueChange(timeStampList[1], "timeStampList");
    }

    const validReportTypesForRbReports = [
      REPORT_TYPES.CLOSING_BALANCE,
      REPORT_TYPES.RUNNING_BALANCE
    ];
    const validReportTypesForCurrency = [
      REPORT_TYPES.CLOSING_BALANCE,
      REPORT_TYPES.DEPOSITS_PAYOUTS,
      REPORT_TYPES.OTC_SETTLEMENTS,
      REPORT_TYPES.PERFORMANCE,
      REPORT_TYPES.RUNNING_BALANCE,
      REPORT_TYPES.SERVER_LOGS,
      REPORT_TYPES.SETTLEMENTS,
      REPORT_TYPES.TRANSACTIONS,
      REPORT_TYPES.OTC_WITHDRAW
    ];
    if (validReportTypesForCurrency.includes(reportType)) {
      if (validReportTypesForRbReports.includes(reportType)) {
        const rbCurrencies = this.getRunningBalanceCurrencies();
        this.onValueChange(rbCurrencies[0], "currency");
      } else {
        this.onValueChange(currency, "currency");
      }
    }

    if (reportType === REPORT_TYPES.PAYOUT) {
      this.onValueChange(payoutStatus, "payoutStatus");
      const payoutMids = this.getPayoutMids();
      this.onValueChange(payoutMids, "midIds");
      this.onValueChange(timeStampList[1], "timeStampList");
    }

    if (reportType === REPORT_TYPES.GROSS_PROFIT) {
      this.onValueChange(baseCurrencies[0], "grossCurrency");
      this.onValueChange(properties[reportType], "properties");
    }

    if (reportType === REPORT_TYPES.SETTLEMENTS || reportType === REPORT_TYPES.OTC_SETTLEMENTS) {
      this.onValueChange(settlementStatuses, "settlementStatus");
    }

    const validReportTypesForMidIds = [
      REPORT_TYPES.CLOSING_BALANCE,
      REPORT_TYPES.DEPOSITS_PAYOUTS,
      REPORT_TYPES.OTC_SETTLEMENTS,
      REPORT_TYPES.PERFORMANCE,
      REPORT_TYPES.RUNNING_BALANCE,
      REPORT_TYPES.SETTLEMENTS,
      REPORT_TYPES.TRANSACTIONS
    ];
    if(validReportTypesForMidIds.includes(reportType)) {
      const mids = this.getMidsByCurrencyAndTimeZone(false, validReportTypesForDeposits.includes(reportType));
      this.onValueChange(mids, "midIds");
    }

    this.onValueChange(displayMode[0], "displayMode");
    this.onValueChange(firstSortBy, "sortBy");
    this.onSelectPeriodChange(defaultTimePeriods[reportType], "timePeriod");
  };

  defineReportForm = (reportType) => {
    const { reportForm, reportFormRules, reportFormData, timeStampList } = this.state;

    const copyArray = (arr) => {
      return JSON.parse(JSON.stringify(arr));
    };

    const payoutForm = new Form ({
      clientIds: reportForm.clientIds,
      companyId: reportForm.companyId,
      payoutStatus: [],
      sortBy: "",
      reportType: reportType,
      displayMode: "",
      sortByDate: reportForm.sortByDate,
      transactionId: "",
      midIds: [],
      timeZone: "",
      timeStampList: timeStampList,
      updateStatus: []
    }, copyArray(reportFormRules.slice(0, 6)).concat([{
      name: "midIds",
      type: "isArray",
      rules: {
        required: true,
        min: 1
      }
    }, {
      name: "payoutStatus",
      type: "isArray",
      rules: {
        required: true,
        min: 1
      }
    }, {
      name: "transactionId",
      type: "isPattern",
      rules: {
        trim: true,
        required: false,
        pattern: "^([0-9a-zA-z#?!@$%^&*-]+)((, +| +, +| + ,|, |,| ,| , )([0-9a-zA-z#?!@$%^&*-]+))*$"
      }
    }]));

    const grossProfitForm = new Form({
      clientIds: [],
      companyId: reportForm.companyId,
      reportType: reportType,
      displayMode: "",
      sortBy: "",
      sortByDate: reportForm.sortByDate,
      properties: [],
      grossCurrency: ""
    }, copyArray(reportFormRules.slice(0, 4)).concat(
      [{
        name: "properties",
        type: "isArray",
        rules: {
          min: 1,
          required: true
        }
      }, {
        name: "grossCurrency",
        type: "isString",
        rules: {
          required: true
        }
      }]
    ));

    const transactionsForm = new Form(
      Object.assign({}, reportFormData, {
        clientIds: reportForm.clientIds,
        companyId: reportForm.companyId,
        displayMode: "",
        reportType: reportType,
        trafficTypes: [],
        midIds: reportForm.midIds || [],
        timeStampList: timeStampList,
        timeZone: "",
        updateStatus: []
      }, reportType === "SERVER_LOGS" ? { orderId: "" } : {}),
      reportType !== "SERVER_LOGS" ? copyArray(reportFormRules) : copyArray(reportFormRules).concat([{
        name: "orderId",
        type: "isString",
        rules: {
          required: false
        }
      }, {
        name: "trafficTypes",
        type: "isArray",
        rules: {
          min: 1,
          required: true
        }
      },{
        name: "midIds",
        type: "isArray",
        rules: {
          min: 1,
          required: true
        }
      }, ])
    );

    const runningBalanceForm = new Form(
      {
        clientIds: reportForm.clientIds,
        companyId: reportForm.companyId,
        reportType: reportType,
        displayMode: "",
        sortBy: "",
        properties: [],
        midIds: [],
        currency: [],
        removeZeroValues: false,
        sortByDate: "DAY",
        hideEmptyRows: true,
        hideEmptyColumns: true
      }, copyArray(reportFormRules.slice(0, 4)).concat(
        [{
          name: "sortBy",
          type: "isString",
          rules: {
            required: true
          }
        },{
          name: "currency",
          type: "isArray",
          rules: {
            required: true,
            min: 1
          }
        }, {
          name: "midIds",
          type: "isArray",
          rules: {
            required: true,
            min: 1
          }
        }, {
          name: "properties",
          type: "isArray",
          rules: {
            required: false
          }
        }]
      )
    );

    const settlementsForm = new Form(
      {
        clientIds: reportForm.clientIds,
        companyId: reportForm.companyId,
        reportType: reportType,
        displayMode: "",
        sortBy: "",
        properties: [],
        currency : [],
        midIds: [],
        invoiceNumber: "",
        settlementStatus: [],
        removeZeroValues: false,
        sortByDate: "DAY"
      }, copyArray(reportFormRules.slice(0, 4)).concat(
        [{
          name: "settlementStatus",
          type: "isArray",
          rules: {
            min: 1,
            required: true
          }
        }, {
          name: "properties",
          type: "isArray",
          rules: {
            required: false
          }
        }, {
          name: "currency",
          type: "isArray",
          rules: {
            required: true,
            min: 1
          }
        }, {
          name: "midIds",
          type: "isArray",
          rules: {
            required: true,
            min: 1
          }
        }, {
          name: "invoiceNumber",
          type: "isPattern",
          rules: {
            required: false,
            pattern: "^[0-9]+$"
          }
        }]
      )
    );

    const performanceForm = new Form(
      Object.assign({}, reportFormData, {
        clientIds: reportForm.clientIds,
        companyId: reportForm.companyId,
        displayMode: "",
        reportType: reportType,
        timeZone: "",
        timeStampList: timeStampList,
        email: "",
        ip: ""
      }),
      copyArray(reportFormRules).concat(
        {
          name: "email",
          type: "isString",
          rules: {
            required: false
          }
        },
        {
          name: "ip",
          type: "isString",
          rules: {
            required: false
          }
        }
      )
    );

    const depositsPayoutsForm = new Form(
      Object.assign({}, reportFormData, {
        clientIds: reportForm.clientIds,
        companyId: reportForm.companyId,
        displayMode: "",
        reportType: reportType,
        trafficTypes: [],
        midIds: reportForm.midIds || [],
        timeStampList: timeStampList,
        timeZone: "",
        transactionId: "",
        updateStatus: []
      }),
      reportType !== "SERVER_LOGS" ? copyArray(reportFormRules).filter(elem => elem.name !== "transactionId") : copyArray(reportFormRules).filter(elem => elem.name !== "transactionId").concat([{
        name: "orderId",
        type: "isString",
        rules: {
          required: false
        }
      }, {
        name: "trafficTypes",
        type: "isArray",
        rules: {
          min: 1,
          required: true
        }
      },{
        name: "midIds",
        type: "isArray",
        rules: {
          min: 1,
          required: true
        }
      }, {
        name: "transactionId",
        type: "isString",
        rules: {
          required: false
        }
      }])
    );

    const closingBalanceForm = new Form(
      {
        clientIds: reportForm.clientIds,
        companyId: reportForm.companyId,
        reportType: reportType,
        displayMode: "",
        sortBy: "",
        properties: [],
        midIds: [],
        currency: [],
        removeZeroValues: false,
        sortByDate: "DAY",
        hideEmptyRows: false,
        hideEmptyColumns: false
      }, copyArray(reportFormRules.slice(0, 4)).concat(
        [{
          name: "sortBy",
          type: "isString",
          rules: {
            required: true
          }
        },{
          name: "currency",
          type: "isArray",
          rules: {
            required: true,
            min: 1
          }
        }, {
          name: "midIds",
          type: "isArray",
          rules: {
            required: true,
            min: 1
          }
        }, {
          name: "properties",
          type: "isArray",
          rules: {
            required: false
          }
        }]
      )
    );

    const otcSettlementsForm = new Form(
      {
        clientIds: reportForm.clientIds,
        companyId: reportForm.companyId,
        reportType: reportType,
        displayMode: "",
        sortBy: "",
        properties: [],
        currency : [],
        midIds: [],
        invoiceNumber: "",
        settlementStatus: [],
        removeZeroValues: false,
        sortByDate: "DAY"
      }, copyArray(reportFormRules.slice(0, 4)).concat(
        [{
          name: "settlementStatus",
          type: "isArray",
          rules: {
            min: 1,
            required: true
          }
        }, {
          name: "properties",
          type: "isArray",
          rules: {
            required: false
          }
        }, {
          name: "currency",
          type: "isArray",
          rules: {
            required: true,
            min: 1
          }
        }, {
          name: "midIds",
          type: "isArray",
          rules: {
            required: true,
            min: 1
          }
        }, {
          name: "invoiceNumber",
          type: "isPattern",
          rules: {
            required: false,
            pattern: "^[0-9]+$"
          }
        }]
      )
    );

    const otcBalancesForm = new Form(
      Object.assign({}, reportFormData, {
        reportType: reportType,
        clientIds: reportForm.clientIds,
        companyId: reportForm.companyId,
      }),
      []
    );

    const otcWithdrawForm = new Form(
      Object.assign({}, reportFormData, {
        reportType: reportType,
        clientIds: reportForm.clientIds,
        companyId: reportForm.companyId,
        currency : [],
      }),
      [{
        name: "clientIds",
        type: "isArray",
        rules: {
          min: 1,
          required: true
        }
      }, {
        name: "currency",
        type: "isArray",
        rules: {
          min: 1,
          required: true,
          extendValue: "CURRENCY"

        }
      }]);

    if (reportType !== REPORT_TYPES.SERVER_LOGS) {
      delete transactionsForm.orderId;
    }

    if (reportType === REPORT_TYPES.GROSS_PROFIT) {
      return grossProfitForm;
    } else if (reportType === REPORT_TYPES.PAYOUT) {
      return payoutForm;
    } else if (reportType === REPORT_TYPES.RUNNING_BALANCE) {
      return runningBalanceForm;
    } else if (reportType === REPORT_TYPES.SETTLEMENTS) {
      return settlementsForm;
    } else if (reportType === REPORT_TYPES.PERFORMANCE) {
      return performanceForm;
    } else if (reportType === REPORT_TYPES.DEPOSITS_PAYOUTS) {
      return depositsPayoutsForm;
    } else if (reportType === REPORT_TYPES.CLOSING_BALANCE) {
      return closingBalanceForm;
    } else if (reportType === REPORT_TYPES.OTC_SETTLEMENTS) {
      return otcSettlementsForm;
    } else if (reportType === REPORT_TYPES.OTC_BALANCES) {
      return otcBalancesForm;
    } else if (reportType === REPORT_TYPES.OTC_WITHDRAW) {
      return otcWithdrawForm;
    } else {
      return transactionsForm;
    }
  };

  onValueChange = (newValue, fieldName) => {
    let { reportForm } = this.state;
    const { clientMids, defaultTimePeriods, isReportErrorFields } = this.state;
    if (typeof newValue === "boolean") {
      reportForm = Object.assign(reportForm, {
        [fieldName]: !newValue
      });
    } else if (newValue.value) {
      reportForm = Object.assign(reportForm, {
        [fieldName]: fieldName === "midIds" || fieldName === "currency" ? [newValue.value] : newValue.value
      });
    } else if (newValue.target) {
      reportForm = Object.assign(reportForm, {
        [fieldName]: newValue.target.value
      });
    } else {
      reportForm = Object.assign(reportForm, {
        [fieldName]: newValue.map(elem => elem.value)
      });
    }

    this.setState({
      currentPage: 1
    });

    const reportType = reportForm.reportType;

    const validReportTypesForRbReports = [
      REPORT_TYPES.CLOSING_BALANCE,
      REPORT_TYPES.RUNNING_BALANCE
    ];

    const validReportTypesForDeposits = [
      REPORT_TYPES.DEPOSITS_PAYOUTS,
      REPORT_TYPES.TRANSACTIONS
    ];

    const validReportTypesForCurrency = [
      REPORT_TYPES.CLOSING_BALANCE,
      REPORT_TYPES.OTC_SETTLEMENTS,
      REPORT_TYPES.OTC_WITHDRAW,
      REPORT_TYPES.TRANSACTIONS,
      REPORT_TYPES.RUNNING_BALANCE,
      REPORT_TYPES.SETTLEMENTS,
      REPORT_TYPES.DEPOSITS_PAYOUTS
    ];

    const validReportTypesForTimezone = [
      REPORT_TYPES.CLOSING_BALANCE,
      REPORT_TYPES.DEPOSITS_PAYOUTS,
      REPORT_TYPES.PAYOUT,
      REPORT_TYPES.RUNNING_BALANCE,
      REPORT_TYPES.TRANSACTIONS
    ];

    if (fieldName === "midIds" && validReportTypesForRbReports.includes(reportType)) {
      reportForm.currency = reportForm.midIds.length ? [clientMids.find(elem => reportForm.midIds.includes(elem.value)).currency] : "";
    } else if (fieldName === "currency" && validReportTypesForCurrency.includes(reportType)) {
      const mids = this.getMidsByCurrencyAndTimeZone(false, validReportTypesForDeposits.includes(reportType));
      reportForm.midIds = mids.map(mid => mid.value);
    } else if (fieldName === "timeZone" && validReportTypesForTimezone.includes(reportType)) {
      if (validReportTypesForTimezone.filter(type => type !== REPORT_TYPES.PAYOUT).includes(reportType)) {
        const mids = this.getMidsByCurrencyAndTimeZone(false, validReportTypesForDeposits.includes(reportType));
        reportForm.midIds = mids.map(mid => mid.value);
      } else if (reportType === REPORT_TYPES.PAYOUT) {
        const mids = this.getPayoutMids();
        reportForm.midIds = mids.map(mid => mid.value);
      }
      const currentPeriod = this.state.dropdowns.periods.find(elem => elem.id === this.state.controls.timePeriod.id);
      this.onSelectPeriodChange(currentPeriod, "timePeriod");
    } else if (fieldName === "trafficTypes" && validReportTypesForDeposits.includes(reportType)) {
      const mids = this.getMidsByCurrencyAndTimeZone(false, true);
      reportForm.midIds = mids.map(mid => mid.value);
    }

    const isReportType = fieldName === "reportType";
    if (isReportType) {
      this.onSelectPeriodChange(defaultTimePeriods[reportType], "timePeriod");
    }

    if (isReportErrorFields) {
      reportForm.isFormValid();
    }

    this.setState({
      reportForm: isReportType ? this.defineReportForm(reportType) : reportForm
    }, () => {
      if (isReportType) {
        this.preselectReportFields(reportType);
      }
    });

    if (fieldName === "sortByDate") {
      this.setState({
        isSortSettingsOpen: false
      });
    }
  };

  getFields = () => {
    const { reportForm, sortBy, currency, payoutStatus, depositMethod, depositStatus,
      depositPayoutStatus, properties, settlementStatuses, trafficTypes } = this.state;

    const isSortByVisible = reportForm.reportType === REPORT_TYPES.PERFORMANCE || reportForm.reportType === REPORT_TYPES.OTC_BALANCES;

    const baseFields = [
      isSortByVisible ? {
        id: "sortBy",
        type: "select",
        label: "Sort By",
        disabled: !reportForm.reportType,
        options: reportForm.reportType ? sortBy[reportForm.reportType] : []
      } : {
        id: !isSortByVisible ? "empty" : ""
      }, {
        id: !isSortByVisible ? "empty" : ""
      }, {
        id: !isSortByVisible ? "empty" : ""
      }, {
        id: !isSortByVisible ? "empty" : ""
      }];

    const buttonField = [{
      id: "button",
      type: "button"
    }];

    const reportFields = {
      [REPORT_TYPES.TRANSACTIONS]: [
        [{
          id: "currency",
          type: "multiselect",
          label: "Currency",
          selectedItems: this.mapSelectedItems("currency", "currency"),
          items: currency,
        }, {
          id: "depositMethod",
          type: "multiselect",
          label: "Payment Method",
          selectedItems: this.mapSelectedItems("depositMethod", "depositMethod"),
          items: depositMethod
        }, {
          id: "depositStatus",
          type: "multiselect",
          label: "Status",
          selectedItems: this.mapSelectedItems("depositStatus", "depositStatus"),
          items: depositStatus
        }, {
          id: "trafficTypes",
          type: "multiselect",
          label: "Traffic",
          selectedItems: this.mapSelectedItems("trafficTypes", "trafficTypes"),
          items: trafficTypes,
        }],
        [{
          id: "midIds",
          type: "multiselect",
          label: "MIDs",
          withId: true,
          selectedItems: this.mapSelectedItems("midIds", "midIds"),
          items: this.getMidsByCurrencyAndTimeZone(false, true),
        }, {
          id: "transactionId",
          type: "textarea",
          label: "Search Transaction ID",
        }, {}, {}], [{}, {}, {
          id:"bulkButton",
          type:"bulkButton"
        }]
      ],
      [REPORT_TYPES.GROSS_PROFIT]: [
        [{
          id: "properties",
          type: "multiselect",
          label: "Properties",
          selectedItems: this.mapSelectedItems("properties", "properties", true),
          items: reportForm.reportType ? properties[reportForm.reportType] : []
        }, {}, {}]
      ],
      [REPORT_TYPES.SERVER_LOGS]: [
        [{
          id: "currency",
          type: "multiselect",
          label: "Currency",
          selectedItems: this.mapSelectedItems("currency", "currency"),
          items: currency,
        }, {
          id: "depositMethod",
          type: "multiselect",
          label: "Payment Method",
          selectedItems: this.mapSelectedItems("depositMethod", "depositMethod"),
          items: depositMethod
        }, {
          id: "depositStatus",
          type: "multiselect",
          label: "Status",
          selectedItems: this.mapSelectedItems("depositStatus", "depositStatus"),
          items: depositStatus
        }, {}],
        [{
          id: "transactionId",
          type: "textarea",
          label: "Search Transaction ID"
        }, {
          id: "orderId",
          type: "input",
          label: "Search Order ID"
        }, {}]
      ],
      [REPORT_TYPES.PAYOUT]: [
        [{
          id: "midIds",
          type: "multiselect",
          label: "Payout MID",
          withId: true,
          selectedItems: this.mapSelectedItems("midIds", "midIds"),
          items: this.getPayoutMids(),
        }, {
          id: "payoutStatus",
          type: "multiselect",
          label: "Payout Status",
          selectedItems: this.mapSelectedItems("payoutStatus", "payoutStatus"),
          items: payoutStatus
        }, {
          id: "transactionId",
          type: "textarea",
          label: "Search Transaction ID"
        }, {}],
        [{}, {}, { 
          id:"bulkButton",
          type:"bulkButton"
        }]
      ],
      [REPORT_TYPES.RUNNING_BALANCE]: [
        [{
          id: "sortBy",
          type: "select",
          label: "Sort By",
          disabled: false,
          options: sortBy[REPORT_TYPES.RUNNING_BALANCE]
        }, {
          id: "currency",
          type: "select",
          label: "Currency",
          disabled: false,
          options: this.getRunningBalanceCurrencies()
        }, {
          id: "midIds",
          type: "multiselect",
          label: "MIDs",
          withId: true,
          selectedItems: this.mapSelectedItems("midIds", "midIds"),
          items: this.getMidsByCurrencyAndTimeZone(false, false)
        }, {}, {}],
        [{
          id: "hideEmptyRows",
          type: "checkbox",
          label: "Hide Empty Rows"
        }, {
          id: "hideEmptyColumns",
          type: "checkbox",
          label: "Hide Empty Columns"
        }, {}]
      ],
      [REPORT_TYPES.SETTLEMENTS]: [
        [{
          id: "currency",
          type: "multiselect",
          label: "Currency",
          selectedItems: this.mapSelectedItems("currency", "currency"),
          items: currency,
        }, {
          id: "settlementStatus",
          type: "multiselect",
          label: "Statuses",
          selectedItems: this.mapSelectedItems("settlementStatus", "settlementStatuses"),
          items: settlementStatuses
        }, {
          id: "midIds",
          type: "multiselect",
          label: "MIDs",
          withId: true,
          selectedItems: this.mapSelectedItems("midIds", "midIds"),
          items: this.getMidsByCurrencyAndTimeZone(false, false)
        }, {}],
        [{
          id: "invoiceNumber",
          type: "input",
          label: "Search Invoice #"
        }, {}, {}]
      ],
      [REPORT_TYPES.PERFORMANCE]: [
        [{
          id: "email",
          type: "textarea",
          label: "Search Email"
        }, {
          id: "ip",
          type: "textarea",
          label: "Search IP Address"
        }, {
          id: "bulkButton",
          type: "bulkButton"
        }]
      ],
      [REPORT_TYPES.DEPOSITS_PAYOUTS]: [
        [{
          id: "currency",
          type: "multiselect",
          label: "Currency",
          selectedItems: this.mapSelectedItems("currency", "currency"),
          items: currency,
        }, {
          id: "depositMethod",
          type: "multiselect",
          label: "Methods",
          selectedItems: this.mapSelectedItems("depositMethod", "depositMethod"),
          items: depositMethod
        }, {
          id: "depositStatus",
          type: "multiselect",
          label: "Status",
          selectedItems: this.mapSelectedItems("depositStatus", "depositStatus"),
          items: depositPayoutStatus
        }, {
          id: "trafficTypes",
          type: "multiselect",
          label: "Traffic",
          selectedItems: this.mapSelectedItems("trafficTypes", "trafficTypes"),
          items: trafficTypes,
        }],
        [{
          id: "midIds",
          type: "multiselect",
          label: "MIDs",
          withId: true,
          selectedItems: this.mapSelectedItems("midIds", "midIds"),
          items: this.getMidsByCurrencyAndTimeZone(false, true)
        }, {
          id: "transactionId",
          type: "textarea",
          label: "Search"
        }, {}, {}],
        [{}, {}, {
          id: "bulkButton",
          type: "bulkButton"
        }]
      ],
      [REPORT_TYPES.CLOSING_BALANCE]: [
        [{
          id: "currency",
          type: "select",
          label: "Currency",
          disabled: false,
          options: this.getRunningBalanceCurrencies()
        }, {}, {}]
      ],
      [REPORT_TYPES.OTC_SETTLEMENTS]: [
        [{
          id: "currency",
          type: "multiselect",
          label: "Currency",
          selectedItems: this.mapSelectedItems("currency", "currency"),
          items: currency,
        }, {
          id: "settlementStatus",
          type: "multiselect",
          label: "Statuses",
          selectedItems: this.mapSelectedItems("settlementStatus", "settlementStatuses"),
          items: settlementStatuses
        }, {
          id: "midIds",
          type: "multiselect",
          label: "MIDs",
          withId: true,
          selectedItems: this.mapSelectedItems("midIds", "midIds"),
          items: this.getMidsByCurrencyAndTimeZone(false, false)
        }, {}],
        [{
          id: "invoiceNumber",
          type: "input",
          label: "Search Invoice #"
        }, {}, {}]
      ],
      [REPORT_TYPES.OTC_BALANCES]: [
        [{}, {}, {
          id: "bulkButton",
          type: "bulkButton"
        }]
      ],
      [REPORT_TYPES.OTC_WITHDRAW]: [
        [{
          id: "currency",
          type: "multiselect",
          label: "Currency",
          selectedItems: this.mapSelectedItems("currency", "currency"),
          items: currency,
        }, {}, {
          id: "bulkButton",
          type: "bulkButton"
        }]
      ],
    };

    const buildFields = (type) => {
      const fields = reportFields[type];
      fields.splice(0, 0, baseFields);
      fields[fields.length - 1] = fields[fields.length - 1].concat(buttonField);

      return fields;
    };

    const selectedReportFields = reportFields[reportForm.reportType];

    if (!selectedReportFields) {
      return buildFields(REPORT_TYPES.TRANSACTIONS);
    }

    return buildFields(reportForm.reportType);
  };

  isDateValid = (current, state) => {
    const { timeStamp, fromDate = timeStamp.fromDateTimeStamp, toDate = timeStamp.toDateTimeStamp,
      reportForm, timeZones, timeZoneType } = this.state;

    let timeZoneOffset = "00:00";
    if (reportForm.timeZone && timeZones.length && timeZoneType !== "TZ_V2") {
      timeZoneOffset = timeZones.find(zone => zone.value === reportForm.timeZone).offset;
    }
    const yesterday = Datetime.moment().utc().zone(timeZoneOffset).subtract(1, 'days');

    if (state === 'fromDateTimeStamp') {
      return Datetime.moment(current).isBefore(!fromDate ? yesterday : toDate);
    }

    return Datetime.moment(current).isAfter(!toDate ? yesterday : Datetime.moment(fromDate).subtract(1, 'days'));
  };

  getPeriod(periodType) {
    let timeZoneOffset = "00:00";
    if (this.state) {
      if (this.state.reportForm.timeZone && this.state.timeZones.length && this.state.timeZoneType !== "TZ_V2") {
        timeZoneOffset = this.state.timeZones.find(zone => zone.value === this.state.reportForm.timeZone).offset;
      }
    }

    const moment = Datetime.moment;

    switch (periodType) {
    case 1: // yesterday
      return {
        from: moment().utc().utcOffset(timeZoneOffset).subtract(1, 'day').hour(0).minute(0).second(0),
        to: moment().utc().utcOffset(timeZoneOffset).subtract(1, 'day').hour(23).minute(59).second(59)
      };
    case 2: // this month
      return {
        from: moment().utc().utcOffset(timeZoneOffset).year(moment().utc().utcOffset(timeZoneOffset).year()).month(moment().utc().utcOffset(timeZoneOffset).month()).date(1).hour(0).minute(0).second(0),
        to: moment().utc().utcOffset(timeZoneOffset).hour(23).minute(59).second(59)
      };
    case 3: // last month
      return {
        from: moment().utc().utcOffset(timeZoneOffset).year(moment().utc().utcOffset(timeZoneOffset).year()).month(moment().utc().utcOffset(timeZoneOffset).month() - 1).date(1).hour(0).minute(0).second(0),
        to: moment().utc().utcOffset(timeZoneOffset).year(moment().utc().utcOffset(timeZoneOffset).year()).month(moment().utc().utcOffset(timeZoneOffset).month() - 1)
          .date(moment().utc().utcOffset(timeZoneOffset).month(moment().utc().utcOffset(timeZoneOffset).month() - 1).daysInMonth()).hour(23).minute(59).second(59)
      };
    case 4: // this year
      let toDate = moment().utc().utcOffset(timeZoneOffset).hour(23).minute(59).second(59);
      if (this.state.reportForm.reportType === REPORT_TYPES.CLOSING_BALANCE) {
        toDate = moment().utc().utcOffset(timeZoneOffset).year(moment().utc().utcOffset(timeZoneOffset).year()).month(moment().utc().utcOffset(timeZoneOffset).month() - 1)
          .date(moment().utc().utcOffset(timeZoneOffset).month(moment().utc().utcOffset(timeZoneOffset).month() - 1).daysInMonth()).hour(23).minute(59).second(59);
      }
      return {
        from: moment().utc().utcOffset(timeZoneOffset).year(moment().utc().utcOffset(timeZoneOffset).year()).month(0).date(1).hour(0).minute(0).second(0),
        to: toDate
      };
    case 5: // last year
      return {
        from: moment().utc().utcOffset(timeZoneOffset).year(moment().utc().utcOffset(timeZoneOffset).year() - 1).month(0).date(1).hour(0).minute(0).second(0),
        to: moment().utc().utcOffset(timeZoneOffset).year(moment().utc().utcOffset(timeZoneOffset).year() - 1).month(11).date(31).hour(23).minute(59).second(59)
      };
    case 6: // last hour
      return {
        from: moment().utc().utcOffset(timeZoneOffset).subtract(1, 'hours'),
        to: moment().utc().utcOffset(timeZoneOffset)
      };
    case 7: // last 6 hours
      return {
        from: moment().utc().utcOffset(timeZoneOffset).subtract(6, 'hours'),
        to: moment().utc().utcOffset(timeZoneOffset)
      };
    case 0: // today
      return {
        from: moment().utc().utcOffset(timeZoneOffset).hour(0).minute(0).second(0),
        to: moment().utc().utcOffset(timeZoneOffset)
      };
    default: // custom period
      return {
        from: moment().utc().utcOffset(timeZoneOffset).hour(0).minute(0).second(0),
        to: moment().utc().utcOffset(timeZoneOffset).hour(23).minute(59).second(59)
      };
    }
  };

  onSelectPeriodChange = (value, id) => {
    const timeStamp = {...this.state.timeStamp};
    const controls = {...this.state.controls};
    value = value === null ? {
      id: 0,
      value: 'today',
      label: 'Today'
    } : value;
    const dateFieldDisabled = value.id !== 8; // depends on any predefined period (today, yesterday etc.)
    const period = this.getPeriod(value.id);

    controls[id] = value;
    timeStamp.fromDateTimeStamp = period.from;
    timeStamp.toDateTimeStamp = period.to;
    controls.from = getFormattedDate(timeStamp.fromDateTimeStamp._d);
    controls.to = getFormattedDate(timeStamp.toDateTimeStamp._d);

    //if this month
    if (value.id === 2) {
      this.thisMonth = true;
    } else {
      this.thisMonth = false;
    }

    this.setState({
      controls: controls,
      dateFieldDisabled: dateFieldDisabled,
      timeStamp: timeStamp,
      currentPage: 1,
      periodId: value.id
    });
  };

  handleDateChange = (event, state, fieldState) => {
    const controls = {...this.state.controls};
    const timeStamp = {...this.state.timeStamp};

    timeStamp[state] = event;
    controls[fieldState] = event;

    this.setState({controls: controls, timeStamp: timeStamp, isSubmitting: false});
  };

  getMidCurrencies = () => {
    const { clientMids } = this.state;
    if (!clientMids) {
      return [];
    }

    return clientMids;
  };

  getRunningBalanceCurrencies = () => {
    const { clientMids } = this.state;

    if (!clientMids) {
      return [];
    }
    const findCurrency = clientMids.map(mid => mid.currency);

    const setData = new Set(findCurrency);
    const uniqueCurrencyArray = Array.from(setData);

    const uniqueCurrencyObj = uniqueCurrencyArray.map(currency => {
      const obj = {};
      obj.value = currency;
      obj.label = currency;
      return obj;
    });

    return uniqueCurrencyObj;
  };

  getMidsByCurrencyAndTimeZone = (filterByTimeZone, filterByTrafficType) => {
    const { reportForm } = this.state;
    const { clientMids } = this.state;
    if (!clientMids) {
      return [];
    }

    let filteredMids = reportForm.currency ? clientMids.filter(mid => reportForm.currency.includes(mid.currency)) : [];

    if (filterByTimeZone && reportForm.timeZone) {
      filteredMids = filteredMids.filter(mid => reportForm.timeZone === mid.timeZone);
    }

    if (filterByTrafficType && reportForm.trafficTypes) {
      filteredMids = filteredMids.filter(mid => reportForm.trafficTypes.includes(mid.trafficType));
    }

    return filteredMids;
  };

  getPayoutMids = () => {
    const { clientPayoutMids } = this.state;

    if (!clientPayoutMids) {
      return [];
    }

    return clientPayoutMids;
  };

  mapSelectedItems = (type, lookupsName, useReportType) => {
    const { reportForm } = this.state;
    const field = reportForm[type];
    const { reportType } = reportForm;
    let lookup = null;
    if (lookupsName === "midIds") {
      const validReportTypes = [
        REPORT_TYPES.CLOSING_BALANCE,
        REPORT_TYPES.DEPOSITS_PAYOUTS,
        REPORT_TYPES.OTC_SETTLEMENTS,
        REPORT_TYPES.RUNNING_BALANCE,
        REPORT_TYPES.SETTLEMENTS,
        REPORT_TYPES.TRANSACTIONS
      ];
      if (validReportTypes.includes(reportType)) {
        const validReportTypesForFilterByTraffic = [
          REPORT_TYPES.DEPOSITS_PAYOUTS,
          REPORT_TYPES.TRANSACTIONS
        ];
        lookup = this.getMidsByCurrencyAndTimeZone(false, validReportTypesForFilterByTraffic.includes(reportType));
      } else if (reportType === REPORT_TYPES.PAYOUT) {
        lookup = this.getPayoutMids();
      }
    } else if (useReportType) {
      lookup = this.state[lookupsName][reportType];
    } else {
      if (type === "depositStatus" && reportType === REPORT_TYPES.DEPOSITS_PAYOUTS) {
        lookup = this.state.depositPayoutStatus;
      } else {
        lookup = this.state[lookupsName];
      }
    }
    if (!field || !lookup || !Array.isArray(field) || field.some(elem => !lookup.find(lookupElem => elem === lookupElem.value))) {
      return [];
    }
    return field.map(elem => {
      return lookup.find(lookupElem => elem === lookupElem.value);
    });
  };

  getReportColumnIndex = (headerId) => {
    const { reportsGenerated } = this.state;
    return reportsGenerated.headers.map(e => e.headerId).indexOf(headerId);
  };

  getFilteredPeriods = (reportType) => {
    const { periods } = this.state.dropdowns;

    if (reportType === REPORT_TYPES.CLOSING_BALANCE) {
      return periods.filter(period => [3, 4, 5].includes(period.id));
    } else if (reportType === REPORT_TYPES.OTC_BALANCES) {
      return periods.filter(period => period.id === 0);
    }

    return periods;
  };

  filterHeaders = (headers) => {
    const { access, generatedReportType } = this.state;

    return generatedReportType === REPORT_TYPES.PERFORMANCE ? headers : headers.filter(elem => {
      if (!elem.permission) {
        return true;
      }
     
      const foundPermission = access.find(accessElem => accessElem.permission === elem.permission);
      if (!foundPermission) {
        return true;
      }

      return foundPermission.state;
    });
  };

  filterData = (data) => {
    const { reportsGenerated, access, generatedReportType } = this.state;
    return generatedReportType === REPORT_TYPES.PERFORMANCE ? data : data.filter((elem, index) => {

      const header = reportsGenerated.headers[index];

      if (!header.permission) {
        return true;
      }

      const foundPermission = access.find(accessElem => accessElem.permission === header.permission);
      if (!foundPermission ) {
        return true;
      }
      
      return foundPermission.state;
    });
  };

  onGenerateReport = () => {
    const { reportForm, timeStamp, timeZones, timeZoneType, endpointGenerateMap, currentPage, rowsAmount,
      periodId, controls, loadingRBReportId, rbIntervalID, dropdowns } = this.state;

    const isReportFormValid = reportForm.isFormValid();
    this.setState({
      reportForm: reportForm,
      isReportErrorFields: true,
      clickButton: true
    });

    if(reportForm.transactionId){
      this.setState({
        enableButton: true
      });
    }

    if (isReportFormValid) {
      this.setState({
        isLoading: true
      });

      const reportFormData = reportForm.data();
      
      const displayMode = reportFormData.displayMode;
      const reportType = reportFormData.reportType;

      const validReportTypesForTime = [
        REPORT_TYPES.DEPOSITS_PAYOUTS,
        REPORT_TYPES.PAYOUT,
        REPORT_TYPES.SERVER_LOGS,
        REPORT_TYPES.TRANSACTIONS
      ];
      if (validReportTypesForTime.includes(reportType)) {
        reportFormData.transactionId = reportFormData.transactionId.trim();
        reportFormData.timeZoneType = timeZoneType;
        reportFormData.timePeriod = dropdowns.periods.find(period => period.id === periodId).value;
      }
      //Is it necessary?
      delete reportFormData.sortByDate;

      const validReportTypesForDateOnlyFormat = [
        REPORT_TYPES.CLOSING_BALANCE,
        REPORT_TYPES.GROSS_PROFIT,
        REPORT_TYPES.OTC_SETTLEMENTS,
        REPORT_TYPES.SETTLEMENTS
      ];
      let dateFormat = "DD.MM.YYYY HH:mm:ss";
      if (validReportTypesForDateOnlyFormat.includes(reportType)) {
        dateFormat = "DD.MM.YYYY";
      }
      if (reportType === REPORT_TYPES.SETTLEMENTS || reportType === REPORT_TYPES.OTC_SETTLEMENTS) {
        delete reportFormData.currency;
      }
      
      const period = this.getPeriod(periodId);

      if (periodId !== 8) {
        //we do not override dates for custom date picker
        timeStamp.fromDateTimeStamp = period.from;
        timeStamp.toDateTimeStamp = period.to;
      }

      let timeZoneOffset = "00:00";
      if (reportForm.timeZone && timeZones.length && timeZoneType !== "TZ_V2") {
        timeZoneOffset = timeZones.find(zone => zone.value === reportForm.timeZone).offset;
      }

      let fromDateTimeStamp = Datetime.moment(timeStamp.fromDateTimeStamp).utc().utcOffset(timeZoneOffset).format(dateFormat);
      let toDateTimeStamp = Datetime.moment(timeStamp.toDateTimeStamp).utc().utcOffset(timeZoneOffset).format(dateFormat);

      if (periodId === 8) {
        fromDateTimeStamp = Datetime.moment(timeStamp.fromDateTimeStamp).format(dateFormat);
        toDateTimeStamp = Datetime.moment(timeStamp.toDateTimeStamp).format(dateFormat);
      }

      let endpoint = endpointGenerateMap[reportType][displayMode];
      if (loadingRBReportId) {
        endpoint += `/${loadingRBReportId}`;
      }

      const validReportTypesForRbReports = [
        REPORT_TYPES.CLOSING_BALANCE,
        REPORT_TYPES.RUNNING_BALANCE
      ];

      (loadingRBReportId ? crudActions.get : crudActions.post)(
        endpoint,
        Object.assign(reportFormData, {
          fromDate: fromDateTimeStamp,
          toDate: toDateTimeStamp,
          pageNumber: currentPage,
          limit: rowsAmount,
          ...(validReportTypesForRbReports.includes(reportType) && { timePeriod: controls.timePeriod.value })
        })).then(
        (reportsGenerated) => {
          if (reportsGenerated) {
            if (reportsGenerated.status === "PENDING" && reportsGenerated.id) {
              this.setState({
                loadingRBReportId: reportsGenerated.id,
                savedGeneratedReport: reportFormData,
                savedSelectedCompany: reportFormData.companyId
              }, () => {
                if (!rbIntervalID) {
                  const interval = setInterval(() => {
                    this.onGenerateReport();
                  }, 5000);
                  this.setState({
                    rbIntervalID: interval
                  });
                }
              });
            } else if (reportsGenerated.status && reportsGenerated.id) {
              this.setState({
                showAlert: true,
                alertType: "error",
                alertMessage: "Oops, something went wrong. Please, try again or change filter parameters.",
                rbIntervalID: null,
                loadingRBReportId: "",
                isLoading: false
              });
              clearInterval(rbIntervalID);
            } else {
              const validReportTypesForHistory = [
                REPORT_TYPES.DEPOSITS_PAYOUTS,
                REPORT_TYPES.PAYOUT,
                REPORT_TYPES.PERFORMANCE,
                REPORT_TYPES.SERVER_LOGS,
                REPORT_TYPES.TRANSACTIONS
              ];

              if (displayMode === "LIST_DETAILED") {
                reportsGenerated.isListDetailed = true;
                reportsGenerated.data = reportsGenerated.data.reduce(
                  (finalArray, currentElem) => {
                    finalArray.push({
                      mainRow: true,
                      content: currentElem.mainRow.concat(Array(reportsGenerated.headers.length - currentElem.mainRow.length).fill(""))
                    });

                    finalArray = finalArray.concat(currentElem.subRows.map(elem => {
                      return {
                        mainRow: false,
                        content: Array(reportsGenerated.headers.length - elem.length).fill("").concat(elem)
                      };
                    }));

                    return finalArray;
                  }, []
                );
              } else if (validReportTypesForHistory.includes(reportType)) {
                reportsGenerated.isHistory = true;
              } else {
                reportsGenerated.isList = true;
              }
              if(reportsGenerated.warningMessage) {
                this.setState({
                  showAlert: true,
                  alertType: "warning",
                  alertMessage: reportsGenerated.warningMessage,
                });
              }
              this.setState({
                rbIntervalID: null,
                loadingRBReportId: "",
                reportsGenerated: reportsGenerated,
                generatedReportType: reportType,
                savedGeneratedReport: reportFormData,
                savedSelectedCompany: reportFormData.companyId,
                isLoading: false,
                cnt: reportsGenerated.cnt,
                lastUpdate: Datetime.moment().format('HH:mm - DD. MMM YYYY')
              });
              clearInterval(rbIntervalID);
            }
          }
        }
      ).catch(
        err => {
          if (err && err.message) {
            this.setState({
              showAlert: true,
              alertType: "error",
              alertMessage: err.message,
              isLoading: false
            });
          }
        }
      );
    } else {
      this.setState({
        showAlert: true,
        alertType: "error",
        alertMessage: "Some fields have errors. Please, fix them in order to continue."
      });
    }
  };

  onExportClick = () => {
    const { reportForm, timeStamp, timeZones, timeZoneType, endpointXlsxMap, periodId, controls,
      loadingRBReportId, rbIntervalID, dropdowns } = this.state;

    const reportFormData = reportForm.data();

    this.setState({
      isExportSettingsOpen: false
    });

    const reportType = reportFormData.reportType;
    const displayMode = reportFormData.displayMode;

    const validReportTypesForDateOnlyFormat = [
      REPORT_TYPES.CLOSING_BALANCE,
      REPORT_TYPES.GROSS_PROFIT,
      REPORT_TYPES.OTC_SETTLEMENTS,
      REPORT_TYPES.SETTLEMENTS
    ];
    let dateFormat = "DD.MM.YYYY HH:mm:ss";
    if (validReportTypesForDateOnlyFormat.includes(reportType)) {
      dateFormat = "DD.MM.YYYY";
    }

    const validReportTypesForTime = [
      REPORT_TYPES.DEPOSITS_PAYOUTS,
      REPORT_TYPES.PAYOUT,
      REPORT_TYPES.SERVER_LOGS,
      REPORT_TYPES.TRANSACTIONS
    ];
    if (validReportTypesForTime.includes(reportType)) {
      reportFormData.timeZoneType = timeZoneType;
      reportFormData.timePeriod = dropdowns.periods.find(period => period.id === periodId).value;
    }

    const period = this.getPeriod(periodId);

    if (periodId !== 8) {
      //we do not override dates for custom date picker
      timeStamp.fromDateTimeStamp = period.from;
      timeStamp.toDateTimeStamp = period.to;
    }

    let timeZoneOffset = "00:00";
    if (reportForm.timeZone && timeZones.length && timeZoneType !== "TZ_V2") {
      timeZoneOffset = timeZones.find(zone => zone.value === reportForm.timeZone).offset;
    }

    let fromDateTimeStamp = Datetime.moment(timeStamp.fromDateTimeStamp).utc().zone(timeZoneOffset).format(dateFormat);
    let toDateTimeStamp = Datetime.moment(timeStamp.toDateTimeStamp).utc().zone(timeZoneOffset).format(dateFormat);

    if (periodId === 8) {
      fromDateTimeStamp = Datetime.moment(timeStamp.fromDateTimeStamp).format(dateFormat);
      toDateTimeStamp = Datetime.moment(timeStamp.toDateTimeStamp).format(dateFormat);
    }

    let endpoint = endpointXlsxMap[reportType][displayMode];
    if (loadingRBReportId) {
      endpoint += `/${loadingRBReportId}`;
    }

    if (!loadingRBReportId) {
      this.setState({
        showAlert: true,
        alertType: "info",
        alertMessage: "Export in progress. It might take some time, depends on data volume."
      });
    }

    const validReportTypesForRbReports = [
      REPORT_TYPES.CLOSING_BALANCE,
      REPORT_TYPES.RUNNING_BALANCE
    ];

    (loadingRBReportId ? crudActions.get : crudActions.post)(
      endpoint,
      Object.assign(reportFormData, {
        fromDate: fromDateTimeStamp,
        toDate: toDateTimeStamp,
        pageNumber: 1,
        limit: INTEGER_MAX,
        ...(validReportTypesForRbReports.includes(reportType) && { timePeriod: controls.timePeriod.value })
      })).then(response => {
      if (response.status === "PENDING" && response.id) {
        this.setState({
          loadingRBReportId: response.id
        }, () => {
          if (!rbIntervalID) {
            const interval = setInterval(() => {
              this.onExportClick();
            }, 5000);
            this.setState({
              rbIntervalID: interval
            });
          }
        });
      } else if (response) {
        response.blob().then(
          result => {
            const dateTime = Datetime.moment().format("DD-MM-YYYY HH-mm-ss");
            saveAs(result, `${dateTime} - ${reportType}.xlsx`);
          }
        );
        this.setState({
          rbIntervalID: null,
          loadingRBReportId: ""
        });
        clearInterval(rbIntervalID);
      }
    }).catch(
      err => {
        this.setState({
          showAlert: true,
          alertType: "error",
          alertMessage: err.message,
          rbIntervalID: null,
          loadingRBReportId: ""
        });
        clearInterval(rbIntervalID);
      }
    );
  };

  onOpenModalClick = (data, type) => {
    if (type === "json" && (data === "{}" || !data)) {
      return;
    }

    try {
      const modalData = type === "json" ? JSON.parse(data) : data;

      this.setState({
        showModal: true,
        modalType: type,
        modalData
      });
    } catch {
      this.setState({
        showAlert: true,
        alertType: "error",
        alertMessage: type === "json" ? "Parsing logs failed." : "Getting notes failed.",
      });
    }
  };

  handleCloseModal = () => {
    this.setState({
      showModal: false,
      historyJson: {}
    });
  };

  onConfirm = () => {
    this.setState({
      showAlert: false,
      alertType: "success",
      alertMessage: ""
    });
  };

  onSortByOpen = () => {
    this.setState({
      isSortSettingsOpen: !this.state.isSortSettingsOpen
    });
  };

  onExportOpen = () => {
    this.setState({
      isExportSettingsOpen: !this.state.isExportSettingsOpen
    });
  };

  isRightAligned = (index) => {
    const { reportsGenerated } = this.state;
    return reportsGenerated.headers[index].headerType === "NUMBER";
  };

  triggerButtonEvent = (headers, headerIndex, row, tableData, tableDataType) => {
    const { savedGeneratedReport, savedSelectedCompany } = this.state;
    const filterHeders = this.filterHeaders(headers);
  
    const buttonSettings = filterHeders.at(headerIndex);
  
    const headersIndexes = headers.filter(elem => buttonSettings.fields.includes(elem.headerId)).map(
      elem => headers.findIndex(header => header.headerId === elem.headerId)
    );

    const data = {};

    headersIndexes.forEach(
      elem => {
        const foundHeader = headers[elem];
        data[foundHeader.headerId] = row[elem];
      }
    );

    if (buttonSettings.endpoint.includes("v1/report-buttons/transactions")) {
      this.setState({
        isModalLoading: true,
        showModal: true,
        modalType: tableDataType,
        modalTitle: "Logs",
        modalData: ""
      });
      crudActions.post(buttonSettings.endpoint, data, {
        Company: savedSelectedCompany,
        Client: savedGeneratedReport.clientIds
      }).then(
        (response) => {
          this.setState({
            isModalLoading: false,
            modalData: JSON.parse(JSON.stringify(response))
          });
        }
      ).catch(
        (err) => {
          if (err && err.message) {
            this.setState({
              showAlert: true,
              alertType: "error",
              alertMessage: err.message,
              showModal: false,
              modalTitle: "",
            });
          }
        }
      );
    } else {
      crudActions.post(buttonSettings.endpoint, data, {
        Company: savedSelectedCompany,
        Client: savedGeneratedReport.clientIds
      }).then(
        (response) => {
          const statusMessage = response.message;
          const endpoint = buttonSettings.endpoint; 

          if (endpoint === "/v1/report-buttons/deposits/check-status" || savedGeneratedReport.reportType === REPORT_TYPES.DEPOSITS_PAYOUTS){
            const status = response.messageType;
            if (status === "SUCCESS") {
              this.setState({
                showAlert: true,
                alertType: "success",
                alertMessage: response.message
              });
            } else if (status === "ERROR") {
              this.setState({
                showAlert: true,
                alertType: "error",
                alertMessage: response.message
              });
            } else if (status === "NEUTRAL") {
              this.setState({
                showAlert: true,
                alertType: "info",
                alertMessage: response.message
              });
            }
          } else {
            this.setState({ 
              showAlert: true,
              alertType: "success",
              alertMessage:  endpoint === "/v1/report-buttons/payouts/check-status" ? statusMessage : "Operation successful."
            });
          }
        }
      ).catch(
        (err) => {
          if (err && err.message) {
            this.setState({
              showAlert: true,
              alertType: "error",
              alertMessage: err.message
            });
          }
        }
      );
    } 
  };

  sendBulkPostback = () => {
    const { reportsGenerated, reportForm, savedSelectedCompany, savedGeneratedReport} = this.state;
    const headers = reportsGenerated.headers;
    const data = reportsGenerated.data;
    const transactionIds = [];
    let index = null;
    if(data && headers){
      const validReportTypesForTrxID = [
        REPORT_TYPES.RISK_AND_SECURITY,
        REPORT_TYPES.TRANSACTIONS
      ];
      if(validReportTypesForTrxID.includes(reportForm.reportType)) {
        index = headers.map(e => e.headerName).indexOf("Trans. ID");
      }
      if(reportForm.reportType === REPORT_TYPES.PAYOUT) {
        index = headers.map(e => e.headerName).indexOf("Payout ID");
      }
      data.forEach(d => {
        transactionIds.push(d[index]);
      });
    }
    const objectTransactionsIds = {};
    objectTransactionsIds.ids = transactionIds;
    if(reportForm.reportType === REPORT_TYPES.TRANSACTIONS) {
      (crudActions.post('v1/report-buttons/deposit/bulk', objectTransactionsIds, {
        Company: savedSelectedCompany,
        Client: savedGeneratedReport.clientIds
      }
      )).then(
        (response) => {
          this.setState({
            ids: transactionIds,
            showAlert: true,
            alertType: "success",
            alertMessage: "Operation successful."
          });}
      ).catch(
        (err) => {
          if (err && err.message) {
            this.setState({
              showAlert: true,
              alertType: "error",
              alertMessage: err.message
            });
          }
        }
      );
    }

    if(reportForm.reportType === REPORT_TYPES.PAYOUT) {
      (crudActions.post('/v1/report-buttons/payout/bulk', objectTransactionsIds, {
        Company: savedSelectedCompany,
        Client: savedGeneratedReport.clientIds
      })).then(
        (response) => {
          this.setState({
            ids: transactionIds,
            showAlert: true,
            alertType: "success",
            alertMessage: "Operation successful."
          });}
      ).catch(
        (err) => {
          if (err && err.message) {
            this.setState({
              showAlert: true,
              alertType: "error",
              alertMessage: err.message
            });
          }
        }
      );
    }
  };

  handleChangePage = (event) => {
    const { currentPage } = this.state;
    let pageNum = currentPage;

    if (event.target.getAttribute('data-testid') === "NavigateBeforeIcon" 
    || event.target.getAttribute('aria-label') === "Go to previous page") {
      pageNum--;
    } else if (event.target.getAttribute('data-testid') === "NavigateNextIcon"
    || event.target.getAttribute('aria-label') === "Go to next page") {
      pageNum++;
    } else
      if (event.target.textContent) {
        pageNum = event.target.textContent;
      }
   
    this.setState({currentPage: pageNum}, () => {
      this.onGenerateReport();
    }); 
  };

  getIcon = () => {
    switch (whiteLabel) {
    case "t365":
      return ReportIconT365;
    case "pacificCapital":
      return ReportIconPacificCapital;
    case "trustbucks":
      return ReportIconTrustbucks;
    default:
      return ReportIcon;
    }
  };

  render() {
    const controls = {...this.state.controls};
    const {
      clickButton,
      cnt,
      currentPage,
      dateFieldDisabled,
      enableButton,
      generatedReportType,
      modalData,
      modalType,
      isLoading,
      isLoadingLookups,
      isModalLoading,
      isSortSettingsOpen,
      isExportSettingsOpen,
      reportForm,
      reportsGenerated,
      reportType,
      rowsAmount,
      showModal,
      sortByDate,
      timeStamp,
      timeStampList,
      timeZones,
      timeZoneType,
      showAlert,
      alertType,
      alertMessage
    } = this.state;
    
    const rows = this.getFields();

    const totalPageCount = Math.ceil(cnt / rowsAmount);
    
    if (!isSortSettingsOpen) {
      this.sortNode = null;
    }

    if (!isExportSettingsOpen) {
      this.exportNode = null;
    }

    if (!reportForm.originalData) {
      return <Row flexGrow={ 1 } className='module generateReports' vertical='start'>
        <span/>
      </Row>;
    }

    const validReportTypesForTime = [
      REPORT_TYPES.DEPOSITS_PAYOUTS,
      REPORT_TYPES.PAYOUT,
      REPORT_TYPES.TRANSACTIONS
    ];

    const validReportTypesForRbReports = [
      REPORT_TYPES.CLOSING_BALANCE,
      REPORT_TYPES.RUNNING_BALANCE,
      REPORT_TYPES.OTC_BALANCES,
    ];

    const validReportTypesForDateOnlyFormat = [
      REPORT_TYPES.GROSS_PROFIT,
      REPORT_TYPES.OTC_SETTLEMENTS,
      REPORT_TYPES.SETTLEMENTS,
      REPORT_TYPES.OTC_BALANCES,
    ];

    const isDateTime = !validReportTypesForDateOnlyFormat.includes(reportForm.reportType);

    const isTimeVisible = !validReportTypesForRbReports.includes(reportForm.reportType) ||
      (validReportTypesForRbReports.includes(reportForm.reportType) && controls.timePeriod.value === "custom");

    const isPerformanceReport = generatedReportType === REPORT_TYPES.PERFORMANCE;

    return (
      <Row flexGrow={ 1 } className={ `${whiteLabel} module generateReports` } vertical='start'>
        <Column flexGrow={ 1 }>
          <ComponentHeader
            title="Generate Report"
            lastUpdate={ this.state.lastUpdate }
            img={ this.getIcon() } />
          <Row flexGrow={ 1 } horizontal='start' wrap={ true } vertical='start'>
            <Column flexGrow={ 1 } vertical='start' className="panel-block">
              <Panel>
                <Panel.Heading className={ whiteLabel }>
                  <Panel.Title>
                    GENERATE REPORT
                  </Panel.Title>
                </Panel.Heading>
                <Panel.Body>
                  <div className="panel-content" style={ {overflow: 'unset'} }>
                    {isLoadingLookups ? (
                      <div style={ { width: "100%", height: "400px", display: "flex", alignItems: "center", justifyContent: "center" } }>
                        <Spinner smallContainer={ true } />
                      </div>
                    ) : (
                      <>
                        <Row flexGrow={ 1 } wrap={ true } horizontal='start' vertical='end'>
                          <Row flexGrow={ 1 } wrap={ true } horizontal='start' vertical='end'>
                            <Column flexGrow={ 1 } vertical='start' alignSelf='start' className="input-column">
                              <label> Report Type </label>
                              <Select
                                id="reportType"
                                name="reportType"
                                value={ reportForm.reportType }
                                required={ true }
                                clearable={ false }
                                disabled={ isLoading }
                                onChange={ (value) => this.onValueChange(value, 'reportType') }
                                options={ reportType }
                              />
                            </Column>
                            <Column flexGrow={ 1 } vertical='start' alignSelf='start' className="input-column">
                              <label> Merchant </label>
                              <input
                                id="client"
                                name="client"
                                className="form-control"
                                value={ this.state.clientName || '' }
                                disabled
                              />
                            </Column>
                            {validReportTypesForTime.includes(reportForm.reportType) ? (
                              <Column flexGrow={ 1 } vertical='start' alignSelf='start' className="input-column">
                                <label> Time Stamp </label>
                                <Select
                                  id="timeStampList"
                                  name="timeStampList"
                                  value={  reportForm.timeStampList }
                                  required={ true }
                                  clearable={ false }
                                  disabled={ isLoading }
                                  onChange={ (value) => this.onValueChange(value, 'timeStampList') }
                                  options={ timeStampList }
                                />
                              </Column>
                            ) : (
                              <Column flexGrow={ 1 } vertical='start' alignSelf='start' className="input-column empty-column">
                                <span/>
                              </Column>
                            )}
                            {validReportTypesForTime.includes(reportForm.reportType) && timeZoneType !== "TZ_V2" ? (
                              <Column flexGrow={ 1 } vertical='start' alignSelf='start' className="input-column">
                                <label> Time Zone </label>
                                <Select
                                  id="timeZone"
                                  name="timeZone"
                                  className={ reportForm.errors.has('timeZone') ? 'error-field' : "" }
                                  value={ reportForm.timeZone }
                                  required={ true }
                                  clearable={ false }
                                  disabled={ isLoading }
                                  onChange={ (value) => this.onValueChange(value, 'timeZone') }
                                  options={ timeZones }
                                />
                              </Column>
                            ) : (
                              <Column flexGrow={ 1 } vertical='start' alignSelf='start' className="input-column empty-column">
                                <span/>
                              </Column>
                            )}
                          </Row>
                        </Row>
                        <Row flexGrow={ 1 } wrap={ true } horizontal='start' vertical='end'>
                          <Column flexGrow={ 1 } vertical='start' alignSelf='start' className="input-column">
                            <label> Time Period </label>
                            <Select
                              id="timePeriod"
                              name="timePeriod"
                              value={ controls.timePeriod.value || '' }
                              required={ true }
                              clearable={ false }
                              enableSort={ false }
                              disabled={ isLoading }
                              onChange={ (value) => this.onSelectPeriodChange(value, 'timePeriod') }
                              options={ this.getFilteredPeriods(reportForm.reportType) }
                            />
                          </Column>
                          {isTimeVisible ? (
                            <Column flexGrow={ 1 } vertical='start' alignSelf='start' className="input-column">
                              <label>From Date</label>
                              <img src={ Calendar } className="calendar-svg" alt=""/>
                              <DatePicker
                                selected={ convertUTCToLocalDate(timeStamp.fromDateTimeStamp) || '' }
                                className="form-control"
                                timeInputLabel="Time:"
                                dateFormat={ `dd.MM.yyyy${isDateTime ? ' HH:mm:ss' : ''}` }
                                timeFormat="HH:mm:ss"
                                showTimeSelect={ isDateTime }
                                timeIntervals={ 15 }
                                filterDate={ (event) => this.isDateValid(event, 'fromDateTimeStamp') }
                                disabled={ dateFieldDisabled || isLoading }
                                onChange={ (date) => this.handleDateChange(convertLocalToUTCDate(date), 'fromDateTimeStamp', 'from') }
                              />
                            </Column>
                          ) : (
                            <Column flexGrow={ 1 } vertical='start' alignSelf='start' className="input-column empty-column">
                              <span/>
                            </Column>
                          )}
                          {isTimeVisible ? (
                            <Column flexGrow={ 1 } vertical='start' alignSelf='start' className="input-column">
                              <label>To Date</label>
                              <img src={ Calendar } className="calendar-svg" alt=""/>
                              <DatePicker
                                selected={ convertUTCToLocalDate(timeStamp.toDateTimeStamp) || '' }
                                className="form-control"
                                timeInputLabel="Time:"
                                dateFormat={ `dd.MM.yyyy${isDateTime ? ' HH:mm:ss' : ''}` }
                                timeFormat="HH:mm:ss"
                                showTimeSelect={ isDateTime }
                                timeIntervals={ 15 }
                                filterDate={ (event) => this.isDateValid(event, 'toDateTimeStamp') }
                                disabled={ dateFieldDisabled || isLoading }
                                onChange={ (date) => this.handleDateChange(convertLocalToUTCDate(date), 'toDateTimeStamp', 'to') }
                              />
                            </Column>
                          ) : (
                            <Column flexGrow={ 1 } vertical='start' alignSelf='start' className="input-column empty-column">
                              <span/>
                            </Column>
                          )}
                          <Column flexGrow={ 1 } vertical='start' alignSelf='start' className="input-column empty-column">
                            <span/>
                          </Column>
                        </Row>
                        {rows.map((row, index) => {
                          return (
                            <Row key={ index } flexGrow={ 1 } wrap={ true } horizontal='start' vertical='end'>
                              {[2, 4].map(count => {
                                return (
                                  <Row key={ index + " " + count } flexGrow={ 1 } wrap={ true } horizontal='start' vertical='end'>
                                    {row.slice(count - 2, count).map((field, fieldIndex) => {
                                      return field.id !== "empty" && (
                                        <Column
                                          key={ field.id + " " + index + " " + fieldIndex }
                                          flexGrow={ field.flexGrow !== undefined ? parseFloat(field.flexGrow) : 1 }
                                          vertical='end'
                                          alignSelf='start'
                                          className="input-column"
                                        >
                                          { field.type !== "checkbox" && !field.notShowOnCondition && (
                                            <label> { field.label } </label>
                                          )}

                                          {field.type === "select" && !field.notShowOnCondition ? (
                                            <Select
                                              className={ reportForm.errors.has(field.id) ? 'error-field' : "" }
                                              value={ field.id === "midIds" || field.id === "currency" ? reportForm[field.id].toString() : reportForm[field.id] }
                                              disabled={ field.disabled || isLoading }
                                              required={ true }
                                              clearable={ false }
                                              options={ field.options }
                                              onChange={ (e) => this.onValueChange(e, field.id) }
                                            />
                                          ) : field.type === "multiselect" && !field.notShowOnCondition ? (
                                            <Multiselect
                                              isError={ reportForm.errors.has(field.id) }
                                              selectedItems={ field.selectedItems }
                                              disabled={ field.disabled || isLoading }
                                              items={ field.items }
                                              type={ field.id }
                                              withId={ field.withId }
                                              onChange={ this.onValueChange }
                                            />
                                          ) : field.type === "input" && !field.notShowOnCondition ? (
                                            <input
                                              className={ "form-control " + (reportForm.errors.has(field.id) ? 'error-field' : "") }
                                              value={ reportForm[field.id] }
                                              disabled={ field.disabled || isLoading }
                                              onChange={ (e) => this.onValueChange(e, field.id) }
                                            />
                                          ) : field.type === "textarea" && !field.notShowOnCondition ? (
                                            <TextareaAutosize 
                                              cacheMeasurements
                                              value={ reportForm[field.id] }
                                              onChange={ (e) => this.onValueChange(e, field.id) }
                                              className={ "form-control " + (reportForm.errors.has(field.id) ? 'error-field' : "") }
                                              disabled={ field.disabled || isLoading }
                                            />
                                          ) : field.type === "bulkButton" && enableButton === true ? (
                                            <Button
                                              type="submit"
                                              className="btn defaultBtn"
                                              disabled={ isLoading }
                                              style={ { outline: isLoading ? "5px auto -webkit-focus-ring-color" : "" } }
                                              onClick={ this.sendBulkPostback }
                                            >
                                              SEND BULK POSTBACKS
                                            </Button> 
                                          ) : field.type === "checkbox" && !field.notShowOnCondition ? (
                                            <Row className="styled-input--square" wrap={ true } horizontal='start' vertical='end' style={ { width: '100%' } }>
                                              <div className="styled-input-single">
                                                <input
                                                  id={ field.id }
                                                  type="checkbox"
                                                  checked={ reportForm[field.id] }
                                                  disabled={ isLoading }
                                                  onChange={ () => this.onValueChange(reportForm[field.id], [field.id]) }
                                                />
                                                <label style={ { fontWeight: "normal" } } htmlFor={ field.id }> { field.label } </label>
                                              </div>
                                            </Row>
                                          ) : field.type === "button" && !field.notShowOnCondition ? (
                                            <Button
                                              type="submit"
                                              className="btn defaultBtn"
                                              disabled={ isLoading }
                                              style={ { outline: isLoading ? "5px auto -webkit-focus-ring-color" : "" } }
                                              onClick={ this.onGenerateReport }
                                            >
                                              GENERATE
                                            </Button>
                                          ) : (
                                            <span/>
                                          )}
                                        </Column>
                                      );
                                    })}
                                  </Row>);
                              })}
                            </Row>);
                        })}
                      </>
                    )}
                      
                  </div>
                </Panel.Body>
              </Panel>
              { isLoading ? (
                <Panel>
                  <Panel.Heading>
                    <Panel.Title> REPORT GENERATED </Panel.Title>
                  </Panel.Heading>
                  <Panel.Body>
                    <div style={ { width: "100%", height: "400px", display: "flex", alignItems: "center", justifyContent: "center" } }>
                      <Spinner smallContainer={ true } />
                    </div>
                  </Panel.Body>
                </Panel>
              ) : reportsGenerated.headers ? (
                <Panel>
                  <Panel.Heading>
                    <Panel.Title>
                      REPORT GENERATED
                    </Panel.Title>
                    <div className="settings-panel">
                      { generatedReportType !== REPORT_TYPES.TRANSACTIONS && (
                        <span className="setting" onClick={ () => this.onSortByOpen() }>
                          <svg className="setting-icon" viewBox="0 0 1792 1792">
                            <path d="M1408 1088q0 26-19 45l-448 448q-19 19-45 19t-45-19l-448-448q-19-19-19-45t19-45 45-19h896q26 0 45 19t19 45zm0-384q0 26-19 45t-45 19h-896q-26 0-45-19t-19-45 19-45l448-448q19-19 45-19t45 19l448 448q19 19 19 45z"/>
                          </svg>
                          <span className="text"> { sortByDate.find(elem => elem.value === reportForm.sortByDate).label } </span>
                        </span>
                      )}
                      <span className="setting" style={ { float: "right", paddingRight: "10px" } } onClick={ () => this.onExportOpen() }>
                        <svg className="setting-icon" viewBox="0 0 32 32">
                          <g>
                            <path clipRule="evenodd" d="M8.624,21.336h2.015c1.402-7.953,8.329-14,16.684-14   c0.35,0,0.683,0.003,1.019,0.006l-3.664,3.663c-0.391,0.391-0.391,1.023,0,1.414c0.195,0.195,0.451,0.293,0.707,0.293   c0.256,0,0.512-0.098,0.707-0.293L32,6.356l-5.907-6.063c-0.391-0.391-1.023-0.391-1.414,0c-0.391,0.391-0.391,1.023,0,1.414   l3.631,3.631c-0.318-0.001-0.62-0.003-0.945-0.003C17.895,5.336,10.066,12.271,8.624,21.336z" fillRule="evenodd"/>
                            <path clipRule="evenodd" d="M29,15c-0.552,0-1,0.448-1,1v14H2V10h9c0.552,0,1-0.448,1-1   c0-0.552-0.448-1-1-1h-0.03H2c-1.104,0-2,0.896-2,2v20c0,1.104,0.896,2,2,2h26c1.104,0,2-0.896,2-2V16C30,15.448,29.552,15,29,15z" fillRule="evenodd"/>
                          </g>
                        </svg>
                        <span className="text"> Export </span>
                      </span>
                    </div>
                    { isSortSettingsOpen && (
                      <div ref={ node => this.sortNode = node } className="sort-settings">
                        {
                          sortByDate.map(elem => {
                            return <p key={ elem.value } className="sort-setting-item" onClick={ () => this.onValueChange(elem, 'sortByDate') }> { elem.label } </p>;
                          })
                        }
                      </div>
                    )}
                    { isExportSettingsOpen && (
                      <div ref={ node => this.exportNode = node } className="export-settings">
                        <p className="export-setting-item" onClick={ () => this.onExportClick() }> Export to Excel </p>
                      </div>
                    )}
                  </Panel.Heading>
                  <Panel.Body>
                    <div className={ `panel-content report-content ${generatedReportType.toLowerCase()}` }>
                      <Table className="table table-striped">
                        <thead>
                          <tr style={ { backgroundColor: '#223679', color: "#FFFFFF" } }>
                            {this.filterHeaders(reportsGenerated.headers).map((column, i) => {
                              return column.headerId !== "ip_country" && (
                                <th
                                  key={ i }
                                  className={ column.headerId === "success_rate" || this.isRightAligned(i) ? "text-right" : (column.headerType === "JSON" || column.headerType === "TEXT" || column.headerName === "Action") ? "text-center" : "" }
                                >
                                  { column.headerName }
                                </th>
                              );
                            })}
                          </tr>
                        </thead>
                        <tbody>
                          {reportsGenerated.data.map((element, i) => {
                            return [ reportsGenerated.isHistory && (
                              <tr key={ i }>
                                {this.filterData(element).map((tableData, j) => {
                                  return this.filterHeaders(reportsGenerated.headers)[j].headerType === "TEXT" ? (
                                    <td
                                      key={ i.toString() + j.toString() }
                                      className={ `text-center ${!tableData ? "no-history" : "history"}` }
                                      onClick={ () => this.onOpenModalClick(tableData, "text") }
                                    >
                                      View
                                    </td>
                                  ) : this.filterHeaders(reportsGenerated.headers)[j].headerType === "JSON" ? (
                                    <td
                                      key={ i.toString() + j.toString() }
                                      className="text-center history"
                                      onClick={ () => this.triggerButtonEvent(reportsGenerated.headers, j, element, tableData, "json") }
                                    >
                                      View
                                    </td>
                                  ) : this.filterHeaders(reportsGenerated.headers)[j].headerType === "BUTTON" ? (
                                    <td key={ i.toString() + j.toString() }>
                                      <Button
                                        className={ `btn ${reportsGenerated.headers[j].headerName === 'Reject' ? 'red-button' : 'action-button'} ${this.filterHeaders(reportsGenerated.headers)[j].permission === "CHECK_STATUS" && element[element.length - 1] === "false" ? 'grey-button' : 'action-button'} ${isPerformanceReport ? (tableData ? "green" : "orange") : "green"}` }
                                        disabled={ isPerformanceReport }
                                        onClick={ () => this.triggerButtonEvent(reportsGenerated.headers, j, element) }
                                      >
                                        { isPerformanceReport ? (tableData ? "Unblock" : "Block") : this.filterHeaders(reportsGenerated.headers)[j].headerName }
                                      </Button>
                                    </td>
                                  ) : this.filterHeaders(reportsGenerated.headers)[j].headerId !== "ip_country" && (
                                    <td
                                      key={ i.toString() + j.toString() }
                                      className={ this.filterHeaders(reportsGenerated.headers)[j].headerId === "success_rate" || this.isRightAligned(j) ? "text-right " : "" }
                                      style={ { minWidth: this.filterHeaders(reportsGenerated.headers)[j].headerId === "ip" ? "170px" : "100px" } }
                                    >
                                      { this.filterHeaders(reportsGenerated.headers)[j].headerId === "ip" && reportsGenerated.data[i][this.getReportColumnIndex('ip_country')] && (
                                        <img
                                          alt={ reportsGenerated.data[i][this.getReportColumnIndex('ip_country')] }
                                          style={ { width: "32px", marginRight: "3px" } }
                                          src={ `http://purecatamphetamine.github.io/country-flag-icons/3x2/${reportsGenerated.data[i][this.getReportColumnIndex('ip_country')]}.svg` }/>
                                      )}
                                      { tableData }
                                    </td>
                                  );
                                })
                                }
                              </tr>
                            ), reportsGenerated.isListDetailed && (
                              <tr key={ i } className={ element.mainRow ? "main-row" : "" } style={ { backgroundColor: !element.mainRow ? '#FFFFFF' : '' } }>
                                { element.content.map((tableData, j) => {
                                  return <td key={ i.toString() + j.toString() } className={ reportsGenerated.headers[j].headerId === "success_rate" || this.isRightAligned(j) ? "text-right" : "" }>
                                    { tableData }
                                  </td>;
                                })
                                }
                              </tr>
                            ), reportsGenerated.isList && (
                              <tr key={ i } style={ {backgroundColor: '#FFFFFF'} }>
                                { element.map((tableData, j) => {
                                  return (reportsGenerated.headers[j].headerType === "TEXT" && tableData) ? (
                                    <td
                                      key={ i.toString() + j.toString() }
                                      className="history"
                                      onClick={ () => this.onOpenModalClick(tableData, "text") }
                                    >
                                      View
                                    </td>
                                  ) : (
                                    <td key={ i.toString() + j.toString() } className={ reportsGenerated.headers[j].headerId === "success_rate" || this.isRightAligned(j) ? "text-right" : "" }>
                                      { tableData }
                                    </td>
                                  );
                                })
                                }
                              </tr>
                            )];
                          })}
                          {reportsGenerated.total && (
                            <tr className="main-row">
                              {reportsGenerated.total.map((elem, i) => {
                                return <td key={ i }>
                                  { elem }
                                </td>;
                              })}
                            </tr>
                          )}
                        </tbody>
                      </Table>
                    </div>
                  </Panel.Body>
                </Panel>
              ) : (
                <span/>
              )}
              {clickButton && totalPageCount > 0 && (
                <Panel style={ {marginTop : "-23px", borderColor : "white", maxHeight: "105px", minHeight: "100px"} }>
                  <Panel.Body>
                    <div className="pagination">
                      <Pagination 
                        count={ totalPageCount } 
                        variant="outlined" 
                        shape="rounded" 
                        page={ Number(currentPage) }
                        onClick= { this.handleChangePage } 
                      />
                    </div>
                  </Panel.Body>
                  
                </Panel>
              )}
            </Column>
          </Row>
        </Column>

        {showAlert && (
          <Alert
            show={ showAlert }
            title={ alertType }
            type={ alertType }
            text={ alertMessage }
            confirmButtonColor={ alertType !== "error" ? getColor(whiteLabel) : "#DD6B55" }
            onConfirm={ this.onConfirm }
          />
        )}

        <Modal
          title={ modalType === "json" ? "Logs" : "Transaction Notes" }
          handleClose={ this.handleCloseModal }
          showModal={ showModal }
          modalType={ modalType }
          data={ modalData }
          isLoading={ isModalLoading }
        />

      </Row>
    );
  }
}

export default GenerateReport;